// src/components/event/EventCreator.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { createEvent } from '../../services/api';

const EventCreator = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [usePassword, setUsePassword] = useState(false);
  const [eventData, setEventData] = useState({
    name: '',
    password: '',
    questions: [''] // Start with one empty question
  });

  const handleAddQuestion = () => {
    if (eventData.questions.length < 8) {
      setEventData(prev => ({
        ...prev,
        questions: [...prev.questions, '']
      }));
    }
  };

  const handleRemoveQuestion = (index) => {
    if (eventData.questions.length > 1) {
      setEventData(prev => ({
        ...prev,
        questions: prev.questions.filter((_, i) => i !== index)
      }));
    }
  };

  const handleQuestionChange = (index, value) => {
    setEventData(prev => ({
      ...prev,
      questions: prev.questions.map((q, i) => i === index ? value : q)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validate questions
      if (eventData.questions.some(q => !q.trim())) {
        setError('All questions must be filled out');
        return;
      }

      const newEvent = {
        id: uuidv4(),
        name: eventData.name,
        password: usePassword ? eventData.password : null,
        questions: eventData.questions,
        responses: [],
        createdAt: new Date().toISOString()
      };

      await createEvent(newEvent);
      navigate('/my-events');
    } catch (err) {
      console.error('Error creating event:', err);
      if (err.code === 'permission-denied' || err.message?.includes('permission')) {
        setError('Permission denied — please set Firestore security rules in the Firebase Console (Firestore → Rules).');
      } else {
        setError(`Error creating event: ${err.message}`);
      }
    }
  };

  return (
    <div className="event-creator">
      <h2>Create New Dartboard</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            placeholder="Event Name"
            value={eventData.name}
            onChange={(e) => setEventData({...eventData, name: e.target.value})}
            className="input-field"
            required
          />
        </div>

        <div className="password-option">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={usePassword}
              onChange={(e) => setUsePassword(e.target.checked)}
            />
            Protect event with password
          </label>
        </div>

        {usePassword && (
          <div className="form-group">
            <input
              type="password"
              placeholder="Set Password"
              value={eventData.password}
              onChange={(e) => setEventData({...eventData, password: e.target.value})}
              className="input-field"
              required={usePassword}
              minLength={4}
            />
          </div>
        )}

        <div className="questions-section">
          <h3>Questions ({eventData.questions.length}/8)</h3>
          {eventData.questions.map((question, index) => (
            <div key={index} className="question-group">
              <input
                type="text"
                placeholder={`Question ${index + 1}`}
                value={question}
                onChange={(e) => handleQuestionChange(index, e.target.value)}
                className="input-field"
                required
              />
              {eventData.questions.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveQuestion(index)}
                  className="icon-button delete"
                >
                  <FaTrash />
                </button>
              )}
            </div>
          ))}
          {eventData.questions.length < 8 && (
            <button
              type="button"
              onClick={handleAddQuestion}
              className="add-question-button"
            >
              <FaPlus /> Add Question
            </button>
          )}
        </div>

        {error && <p className="error-message">{error}</p>}

        <button type="submit" className="submit-button">
          Create Event
        </button>
      </form>
    </div>
  );
};

export default EventCreator;
